module.exports = __webpack_public_path__ + "static/media/people.f7884496.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/people.svg
// module id = 477
// module chunks = 0